import Map from 'components/Map'
import React from 'react'

const NetworkMapPage = () => {
    return (
        <div>
            <Map initSearchType="05" isNewPage />
        </div>
    )
}

export default NetworkMapPage
